import PropTypes from 'prop-types'
import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'

// Internal components
import Button from '../Button/Button'
import { UserContext } from '../../context/UserContext'

const FormDialog = (props) => {
  const { dialogEvent, item, enabledState, onFormDialogConfirm, onFormDialogDecline } = props

  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const [bodyState, setBodyState] = useState(false)
  const [relatedState, setRelatedState] = useState(false)

  const content = item.dialog

  const createMarkup = (copy) => ({ __html: copy })

  useEffect(() => {
    if (!dialogEvent) return false

    const value = dialogEvent.target.options[dialogEvent.target.selectedIndex].text.toLowerCase()
    const bodyString = t(content.body).replace('[VALUE]', value)
    if (bodyString) setBodyState(bodyString)

    const enabledItems = enabledState.filter((input) => input.enabled && !input.toEmpty && input.name !== item.name)
    if (enabledItems.length !== 0) {
      setRelatedState(enabledItems)
    } else {
      onFormDialogConfirm()
    }
  }, [dialogEvent])

  return (
    <div className="FormDialog">
      {content.heading && <h4 className="FormDialog-heading">{t(content.heading)}</h4>}
      {(bodyState || content.prompt) && (
        <div className="FormDialog-body">
          {bodyState && <p dangerouslySetInnerHTML={createMarkup(bodyState)} />}
          {relatedState && (
            <ul>
              {relatedState.map((item, index) => {
                return <li key={`relatedItem--${index}`}>{t(item.label)}</li>
              })}
            </ul>
          )}
          {content.prompt && (
            <p>
              <strong>{t(content.prompt)}</strong>
            </p>
          )}
        </div>
      )}
      <div className="FormDialog-buttonGroup">
        {content.confirmLabel && (
          <Button
            label={t(content.confirmLabel)}
            modifiers={['Button--selectDialogConfirm']}
            onClick={() => onFormDialogConfirm()}
          />
        )}
        {content.declineLabel && (
          <Button
            label={t(content.declineLabel)}
            modifiers={['Button--selectDialogDecline']}
            onClick={() => onFormDialogDecline()}
          />
        )}
      </div>
    </div>
  )
}

FormDialog.propTypes = {
  dialogEvent: PropTypes.any,
  item: PropTypes.object,
  enabledState: PropTypes.any,
  onFormDialogConfirm: PropTypes.func,
  onFormDialogDecline: PropTypes.func
}

export default FormDialog
